import React, { useEffect, useState } from "react";
import { Pencil } from "lucide-react";
import { APIUtility } from "../../../Api";
import { useDispatch } from "react-redux";
import { addToast } from "../../../Redux/CommonSlice/toastSlice";

function ConnectivityComponent({permissions}) {

  const [isSAPEditMode, setIsSAPEditMode] = useState(false);
  const [isOCREditMode, setIsOCREditMode] = useState(false);
  const [ThirdPartLinks, setThirdPartLinks] = useState(null);
  const [linksData, setLinksData] = useState({ocr_links: [],sap_links: []});
  const [isLinksAdded, setIsLinksAdded] = useState({sap: false,ocr: false});

  const dispatch = useDispatch();

  const handleToggleSAP = () => {
    setIsSAPEditMode(!isSAPEditMode);
    if (isSAPEditMode && linksData && linksData?.sap_links != "") {
      if (isLinksAdded.sap) {
        const id = ThirdPartLinks["sap_links"][0]?.id;
        addThirdPartyLink(linksData?.sap_links, "sap", id);
      } else {
        addThirdPartyLink(linksData?.sap_links, "sap");
      }
    }
  };

  const getThirdPartyLinksData = async () => {
    try {
      const res = await APIUtility.getThirdPartlink();

      if (res.status == 200) {
        setThirdPartLinks(res.data);

        if (res.data.sap_links && res.data.sap_links.length > 0) {
          setLinksData((prevData) => ({
            ...prevData,
            sap_links: res.data["sap_links"][0]?.url,
          }));
          setIsLinksAdded((prevData) => ({ ...prevData, sap: true }));
        } else {
          setIsLinksAdded((prevData) => ({ ...prevData, sap: false }));
        }

        if (res.data.ocr_links && res.data.ocr_links.length > 0) {
          setIsLinksAdded((prevData) => ({ ...prevData, ocr: true }));
          setLinksData((prevData) => ({
            ...prevData,
            ocr_links: res.data["ocr_links"][0]?.url,
          }));
        } else {
          setIsLinksAdded((prevData) => ({ ...prevData, ocr: false }));
        }
      }
    } catch (error) {
      setThirdPartLinks(null);
    }
  };

  useEffect(() => {
    getThirdPartyLinksData();
  }, []);

  const handleToggleOCR = () => {
    setIsOCREditMode(!isOCREditMode);
    if (isOCREditMode && linksData && linksData?.ocr_links != "") {
      if (isLinksAdded.sap) {
        const id = ThirdPartLinks["ocr_links"][0]?.id;
        addThirdPartyLink(linksData?.ocr_links, "ocr", id);
      } else {
        addThirdPartyLink(linksData?.ocr_links, "ocr");
      }
    }
  };

  const addThirdPartyLink = async (url, type, id) => {
    try {
      const Data = {
        url: url,
        link_type: type,
      };
      let res;
      if (id) {
        Data["id"] = id;
        res = await APIUtility.UpdateThirdPartlink(Data);
      } else {
        res = await APIUtility.AddThirdPartlink(Data);
      }
      if (res.status == 200 || res.status == 201) {
        dispatch(
          addToast({
            message: "Connectivity API Saved Successfully",
            isError: false,
          })
        );
        getThirdPartyLinksData();
      }
    } catch (error) {
      console.log(error, "error");
      dispatch(
        addToast({
          message: error.message || "Failed to update Alert Configuration",
          isError: true,
        })
      );
    }
  };

  return (
    <div className=" w-full h-full gap-2.5 relative">
      <div className=" w-full mt-2.5">
        <p className="text-black/50 font-semibold font-['Roboto'] text-lg">
          Connectivity
        </p>
      </div>

      {/* SAP Integration Section */}
      <div className="w-full absolute top-[40px]">

      <div className="flex flex-col m-0 w-full h-auto p-2.5 gap-1 mb-3 bg-white rounded-lg">
        <p className="font-bold text-base mb-1 font-['Roboto']">
          SAP Integration
        </p>
        <p className="text-neutral-400 mb-2 font-normal font-['Roboto']">
          This integration ensures that information such as vehicle details and
          reporting numbers are accurately validated and synchronized, enhancing
          operational efficiency and data accuracy.
        </p>
        <div className="flex justify-between w-full h-auto gap-2.5">
          {isSAPEditMode ? (
            <input
              type="text"
              placeholder="Enter SAP API Link"
              value={linksData?.sap_links}
              onChange={(e) =>
                setLinksData({ ...linksData, sap_links: e.target.value })
              }
              className="border w-full px-2 rounded-md"
            />
          ) : (
            <p
              className={`font-bold font-['Roboto'] w-full rounded-[5px] p-2.5 ${
                isSAPEditMode
                  ? "border border-neutral-200"
                  : "bg-stone-300 bg-opacity-20"
              }`}
            >
              {isLinksAdded.sap
                ? ThirdPartLinks["sap_links"][0]?.url
                : "+ Add SAP API Link "}
            </p>
          )}
          {isSAPEditMode ? (
            <button
              className="flex justify-center items-center bg-yellow-400 p-2.5 rounded-lg h-11 w-[71px] text-black text-base font-medium font-['Roboto']"
              onClick={handleToggleSAP}
            >
              Save
            </button>
          ) : (
            permissions?.connectivity_add_button && 
            <button
              className="flex justify-center items-center bg-yellow-400 p-1.5 rounded-lg h-11 w-11"
              onClick={handleToggleSAP}
            >
              <Pencil />
            </button>
          )}
        </div>
      </div>

      {/* OCR Integration Section */}

      <div className="flex flex-col w-full h-auto p-2.5 gap-1 mb-2.5 bg-white rounded-lg">
        <p className="font-bold text-base mb-1 font-['Roboto']">
          OCR Integration
        </p>
        <p className="text-neutral-400 mb-2 font-normal font-['Roboto']">
          This integration ensures that information such as vehicle details and
          reporting numbers are accurately validated and synchronized, enhancing
          operational efficiency and data accuracy.
        </p>
        <div className="flex justify-between w-full h-auto gap-2.5">
          {isOCREditMode ? (
            <input
              type="text"
              placeholder=" Enter OCR API Link"
              value={linksData?.ocr_links}
              onChange={(e) => {
                setLinksData({ ...linksData, ocr_links: e.target.value });
              }}
              className="border w-full px-2 rounded-md"
            />
          ) : (
            <p
              className={`font-bold font-['Roboto'] w-full rounded-[5px] p-2.5 ${
                isOCREditMode
                  ? "border border-neutral-200"
                  : "bg-stone-300 bg-opacity-20"
              }`}
            >
              {isLinksAdded.ocr
                ? ThirdPartLinks["ocr_links"][0]?.url
                : "+ Add OCR API Link "}
            </p>
          )}

          {isOCREditMode ? (
            <button
              className="flex justify-center items-center bg-yellow-400 p-2.5 rounded-lg h-11 w-[71px] text-black text-base font-medium font-['Roboto']"
              onClick={handleToggleOCR}
            >
              Save
            </button>
          ) : (
            permissions?.connectivity_add_button &&
            <button
              className="flex justify-center items-center bg-yellow-400 p-1.5 rounded-lg h-11 w-11"
              onClick={handleToggleOCR}
            >
              <Pencil />
            </button>
          )}
        </div>
      </div>
      </div>


    </div>
  );
}

export default ConnectivityComponent;